module.exports = __webpack_public_path__ + "img/Carport_1.fcbcb9c7.jpg";